module.exports = __webpack_public_path__ + "static/media/banner-amor-cascavel.ca4686b8.jpg";